import React, { useEffect, useState, useMemo } from "react";

import {
    Routes,
    Route,
    Outlet,
} from "react-router-dom";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {
    Button,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    Chip,
    Grid,
    CardContent,
    Card,
    ButtonBase,
} from "@mui/material";
import { TableContainer } from '@mui/material';

import Paper from '@mui/material/Paper';

import Alert from '@mui/material/Alert';
import useWebSocket from 'react-use-websocket';
import { useCookies } from 'react-cookie';


import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import InventoryProgress from "./Inventur/InventoryProgress";
import TimeRangeSelector from "./Inventur/TimeRangeSelector";
import { InventoryLayout } from "./Inventur";


const socketUrl = 'wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production';


const InventurReport = ({ posConfig }) => {
    return (
        <>
            <Routes>
                <Route path="/" element={<InventoryLayout />}>
                    <Route index element={<SlotInventory posConfig={posConfig} />} />
                </Route>
            </Routes>
        </>
    )
}

export default InventurReport;


const SlotInventory = ({ posConfig }) => {

    const [cookies, setCookie] = useCookies(['checkinDeviceId']);
    const [temp, setTemp] = useState("");

    const save = () => {
        const expires = new Date(Date.now() + 60 * 60 * 24 * 366 * 1000)
        setCookie('checkinDeviceId', temp, { path: '/', expires })
    };

    if (!cookies.checkinDeviceId) {
        return <Paper sx={{ p: 2 }}><Typography>Device ID (10-99) Festlegen</Typography><TextField onChange={(evt) => { setTemp(evt.target.value) }} /><Button disabled={temp.length !== 2} onClick={save}>Speichern</Button></Paper>
    }



    return (
        <StoreShipmentApp posConfig={posConfig} />
    )
}


const EditShipment = () => { };




const StoreShipmentApp = ({ posConfig }) => {


    const [cookies] = useCookies(['secret', 'station', 'staff', 'checkinDeviceId']);

    const { sendMessage, readyState } = useWebSocket(socketUrl,
        {
            queryParams: {
                station: posConfig.connection.station,
                secret: cookies.secret,
                staff: cookies.staff
            },
            onMessage: (message) => handleWebsocketEvent(message),
            shouldReconnect: (_closeEvent) => true,
            retryOnError: true,
            onClose: () => console.log('closing'),
            onError: (err) => console.log('error', err),
            onReconnectStop: (err) => console.log('recon stop', err),
        }
    );


    const getInventorySummaryReport = () => {
        sendMessage(JSON.stringify({ task: 'getInventorySummaryReport', station: posConfig.connection.station, staff: cookies.staff, did: cookies.checkinDeviceId, from, to }))
    };



    const [inventorySummaryReport, setInventorySummaryReport] = useState();
    const [from, setFrom] = useState('2025-01-01 00:00:00')
    const [to, setTo] = useState('2025-12-31 23:59:59')


    useEffect(() => {
        getInventorySummaryReport();
    }, [to, from])


    const handleWebsocketEvent = (lastMessage) => {

        const msg = JSON.parse(lastMessage.data)
        console.log(msg)


        if (msg.task === 'respGetInventorySummaryReport') {
            setInventorySummaryReport(msg);
        }



    };


    if(! inventorySummaryReport) return <></>

    return (
        <Box>
            <Box sx={{ pb: 4 }}>
                <Card >
                    <CardContent>
                        <Box display="flex" gap={3}>
                            <DateTimeRangeInput to={to} from={from} setTo={setTo} setFrom={setFrom} period={inventorySummaryReport?.period} />
                            <TimeRangeSelector
                                setFrom={setFrom}
                                setTo={setTo}
                                formatForState={(date) => date.toISOString().slice(0, 19).replace('T', ' ')}
                            />
                        </Box>
                    </CardContent>
                    <CardContent>
                        <InventoryProgress data={inventorySummaryReport.stats} />
                    </CardContent>
                    <CardContent>
                        <InventorySummary inventorySummaryReport={inventorySummaryReport} />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
}



const InventorySummary = ({ inventorySummaryReport }) => {
    const [activeTab, setActiveTab] = useState('missing');


    const { summary, relocationRecommendations, period } = inventorySummaryReport;

    const { detailsByType } = useMemo(() => {
        const details = {
            missing: [],
            duplicate: [],
            unexpected: []
        };

        inventorySummaryReport.rows?.forEach(row => {
            const inv = row.inventory_result;
            const expected = inv.expected || {};
            const unexpected = inv.unexpected || [];

            for (const [sid, count] of Object.entries(expected)) {
                if (count === 0) {
                    details.missing.push({ sid, location_id: row.location_id });
                } else if (count > 1) {
                    details.duplicate.push({ sid, location_id: row.location_id, count });
                }
            }

            for (const sid of unexpected) {
                details.unexpected.push({ sid, location_id: row.location_id });
            }
        });

        return { detailsByType: details };
    }, [inventorySummaryReport]);

    if (!inventorySummaryReport) return <Typography sx={{ p: 2 }}>Loading summary...</Typography>;

    const getTableRows = () => {
        switch (activeTab) {
            case 'missing':
                return (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>Fehlende Sendungen</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>MPS Id</TableCell>
                                        <TableCell>Lagerort</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {detailsByType.missing.map((item, i) => (
                                        <TableRow key={i}>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{item.sid}</TableCell>
                                            <TableCell>{item.location_id}</TableCell>
                                            <TableCell sx={{ color: 'red' }}>Fehlt</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                );
            case 'duplicate':
                return (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>Doppelte Sendungen</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>MPS Id</TableCell>
                                        <TableCell>Lagerort</TableCell>
                                        <TableCell>Scans</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {detailsByType.duplicate.map((item, i) => (
                                        <TableRow key={i}>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{item.sid}</TableCell>
                                            <TableCell>{item.location_id}</TableCell>
                                            <TableCell>{item.count}</TableCell>
                                            <TableCell sx={{ color: 'orange' }}>Duplikat</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                );
            case 'unexpected':
                return (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>Unerwartete Sendungen</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>MPS Id</TableCell>
                                        <TableCell>Lagerort</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {detailsByType.unexpected.map((item, i) => (
                                        <TableRow key={i}>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{item.sid}</TableCell>
                                            <TableCell>{item.location_id}</TableCell>
                                            <TableCell sx={{ color: 'darkorange' }}>Nicht an diesem Lagerplatz erwartet</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                );
            case 'relocation':
                return (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>Umlagerungs-Vorschläge</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>MPS Id</TableCell>
                                        <TableCell>Gefunden an Lagerort</TableCell>
                                        <TableCell>Empfehlung</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {relocationRecommendations.map((rec, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{rec.trackingNumber}</TableCell>
                                            <TableCell>
                                                {rec.foundIn.map((loc, i) => (
                                                    <Chip key={i} label={loc} size="small" sx={{ mr: 0.5 }} color="info" />
                                                ))}
                                            </TableCell>
                                            <TableCell>{rec.suggestion}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <Box>

            {/* KPI Selector Cards */}
            <Grid container spacing={2} sx={{ mb: 4 }}>
                <SummaryCard
                    icon={<InventoryIcon sx={{ color: 'red' }} />}
                    label="Fehlende Sendungen"
                    value={summary?.totalMissing}
                    color="error.main"
                    tabKey="missing"
                    activeTab={activeTab}
                    onClick={setActiveTab}
                />
                <SummaryCard
                    icon={<ReportProblemIcon sx={{ color: 'orange' }} />}
                    label="Doppelte Sendungen"
                    value={summary?.totalDuplicate}
                    color="warning.main"
                    tabKey="duplicate"
                    activeTab={activeTab}
                    onClick={setActiveTab}
                />
                <SummaryCard
                    icon={<LocalShippingIcon sx={{ color: 'goldenrod' }} />}
                    label="Unerwartete Sendungen"
                    value={summary?.totalUnexpected}
                    color="warning.dark"
                    tabKey="unexpected"
                    activeTab={activeTab}
                    onClick={setActiveTab}
                />
                <SummaryCard
                    icon={<MoveUpIcon sx={{ color: 'blue' }} />}
                    label="Falsch gelagerte Sendungen"
                    value={relocationRecommendations?.length || 0}
                    tabKey="relocation"
                    activeTab={activeTab}
                    onClick={setActiveTab}
                />
            </Grid>

            {/* Detail Table */}
            {getTableRows()}
        </Box>
    );
};



const formatForInput = (dateTimeString) => {
    // Converts "YYYY-MM-DD HH:mm:ss" to "YYYY-MM-DDTHH:mm"
    return dateTimeString.replace(' ', 'T').slice(0, 16);
};

const formatForState = (inputValue) => {
    // Converts "YYYY-MM-DDTHH:mm" to "YYYY-MM-DD HH:mm:00"
    return inputValue.replace('T', ' ') + ':00';
};
const DateTimeRangeInput = ({ from, setFrom, to, setTo, period }) => {
    return (

        <>
            <TextField
                label="Von"
                type="datetime-local"
                size="small"
                value={formatForInput(from)}
                onChange={(e) => setFrom(formatForState(e.target.value))}
                InputLabelProps={{ shrink: true }}
            />
            <TextField
                label="Bis"
                type="datetime-local"
                size="small"
                value={formatForInput(to)}
                onChange={(e) => setTo(formatForState(e.target.value))}
                InputLabelProps={{ shrink: true }}
            />
            <Box sx={{ flex: 2 }}> </Box>
            <Typography variant="body2" color="text.secondary" sx={{ alignSelf: 'center' }}>
                Report-Zeitraum: {period?.from} - {period?.to}
            </Typography>
        </>

    );
};

const SummaryCard = ({ icon, label, value, color, tabKey, activeTab, onClick }) => (
    <Grid item xs={12} sm={6} md={3}>
        <ButtonBase onClick={() => onClick(tabKey)} sx={{ width: '100%' }}>
            <Paper
                elevation={tabKey === activeTab ? 2 : 1}
                sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    bgcolor: tabKey === activeTab ? '#ebebeb' : 'white'
                }}
            >
                {icon}
                <Box sx={{ ml: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary">{label}</Typography>
                    <Typography variant="h6" color={color || 'text.primary'}>{value}</Typography>
                </Box>
            </Paper>
        </ButtonBase>
    </Grid>
);